export default "__VITE_ASSET__DNTBsK0o__"